import { render, staticRenderFns } from "./StatusAction.vue?vue&type=template&id=8a36e8b2"
import script from "./StatusAction.vue?vue&type=script&lang=js"
export * from "./StatusAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports